
import QuestPage from "../components/QuestPage";
import AnnotationsModal from "../components/AnnotationsModal";
import Progress from "../components/Progress";
import { useEffect, useState, useCallback } from "react";
import dpages from "../data/pages.json";
import categories from "../data/categories.json";
import questions from "../data/questions.json";
import "../styles/components/quest.scss";
import { Base64 } from "../helpers/base64";
//import { useNavigate } from "react-router-dom";

const Quest = () => {
  //const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [steps, setSteps] = useState([]);
  const [maxPages, setMaxPages] = useState(0);
  const [currentPage, setcurrentPage] = useState(0);
  const [loadedPage, setLoadedPage] = useState(null);
  const [canMoveForward, setCanMoveForward] = useState(true);
  const [resultsId, setResultsId] = useState(null);
  const [showAnnotations, setShowAnnotations] = useState(false);


  const handleOpenAnnotation = (e) => {
    e.preventDefault();
    setShowAnnotations(true);
  };

  const calcScore = useCallback(() => {
    console.log("Calculating score...");
    let scores = [];
    let totalScore = 0;

    categories.forEach((category) => {
      let catScore = 0;

      pages
        .filter((page) => page.type === "question" && page.category === category.id)
        .forEach((question) => {
          //console.log("[Q]", question.id, question.title, question.response);
          question.responses.forEach((response) => {
            if (response.id === question.response) {
              //console.log("[R]", response.id, response.option, response.value);
              catScore += response.value;
            }
          });
        });

      scores.push({ key: category.id, score: catScore });
      totalScore += catScore;
    });

    scores.push({ key: "total", score: totalScore });
    setResultsId(Base64.encode(JSON.stringify(scores)));
  }, [pages]);

  useEffect(() => {
    loadPages();
  }, []);

  useEffect(() => {
    const lPage = pages.find((page) => page.order === currentPage);
    setCanMoveForward(true);
    if (lPage && lPage.type === "question" && lPage.response === "") {
      setCanMoveForward(false);
    }

    if (currentPage === maxPages - 1) {
      calcScore();
    }
    setLoadedPage(lPage);

  }, [currentPage, maxPages, pages, calcScore]);

  useEffect(() => {
    const handleScrollOrResize = () => {
      const questActions = document.querySelector('.quest-actions');
      const questContainer = document.querySelector('.quest-container');
      if (questActions && questContainer) {
        const containerBottom = questContainer.getBoundingClientRect().bottom;
        const windowHeight = window.innerHeight;

        if (containerBottom <= windowHeight) {
          questActions.classList.remove('fixed');
        } else {
          questActions.classList.add('fixed');
        }
      }
    };

    window.addEventListener('scroll', handleScrollOrResize);
    window.addEventListener('resize', handleScrollOrResize);

    return () => {
      window.removeEventListener('scroll', handleScrollOrResize);
      window.removeEventListener('resize', handleScrollOrResize);
    };
  }, []);

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setcurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < maxPages) {
      setcurrentPage(currentPage + 1);
    }
  };

  const gotoPage = (page) => {
    setcurrentPage(page);
  };

  const handleShowResults = () => {
    const base_url = process.env.NODE_ENV === 'development' ? process.env.PUBLIC_URL : '/test-habitos-activia';
    //navigate(`${base_url}/results?ghts=${resultsId}`);
    //navigate(0);// force reload page

    // We need to force de page reload to show the CTA button
    window.location.href = `${base_url}/results?ghts=${resultsId}`;
  };

  const setResponse = (response) => {
    setCanMoveForward(true);
  };



  /**
   * Generate pages and steps
   */
  const loadPages = () => {
    let order = 0;
    let pg = [];
    let st = [];

    dpages.forEach((page) => {
      if (page.type === "info") {
        page.order = order++;
        pg.push(page);
        if (page.isStep === "true") {
          st.push(page);
        }
      }

      if (page.type === "quiz") {
        categories.forEach((category) => {
          category.order = order++;
          pg.push(category);
          st.push(category);

          const catQuestions = questions.filter((question) => question.category === category.id);

          catQuestions.forEach((question, i) => {
            question.order = order++;
            question.color = category.color;
            question.breadcrum = `${category.title} | Pregunta ${i + 1} de ${catQuestions.length}`;
            question.response = "";
            pg.push(question);
          });
        });
      }
    });

    setPages(pg);
    setSteps(st);
    setMaxPages(pg.length);
  };

  return (
    <>
      <Progress currentPage={currentPage} steps={steps} gotoPage={gotoPage} />

      <div className="quest-page">
        <div className="quest-container">
          <div className="quest-steps" style={{ transform: `translateX(-${currentPage * 100}%)` }}>
            {pages.map((page) => (
              <QuestPage page={page} active={currentPage === page.order} setResponse={setResponse} key={page.order} />
            ))}
          </div>
        </div>

        <div className="quest-actions">
          <div className="buttons-bar">
            <button className={`ght-button ${currentPage === 0 ? "hide" : ""}`} onClick={handlePrevPage}>
              <span>Anterior</span>
            </button>
            <button className={`ght-button ${currentPage >= maxPages - 1 ? "hide" : ""} `} onClick={handleNextPage} disabled={!canMoveForward}>
              <span>Siguiente</span>
            </button>
            <button className={`ght-button ${currentPage >= maxPages - 1 ? "" : "hide"}`} onClick={handleShowResults} disabled={!resultsId}>
              <span>Ver resultados</span>
            </button>
          </div>
          <div className="annotation-trigger">
            {loadedPage && loadedPage.type === "question" && loadedPage.annotations.length > 0 && (
              <span onClick={handleOpenAnnotation}><sup>(*)</sup> Consulta las fuentes <a href="#ref">aquí</a></span>
            )}
          </div>
        </div>
      </div>

      <div className="legal-quote">
        <span>En ningún caso este plan de hábitos saludables ha sido creado para sustituir las indicaciones nutricionales y tratamientos médicos que te hayan sido prescritos. Es muy importante consultar con un profesional para que te asesore sobre recomendaciones específicas que estén completamente adaptadas a tu estado de salud.</span>
      </div>


      {loadedPage && loadedPage.type === "question" && loadedPage.annotations.length > 0 && (
        <AnnotationsModal key={loadedPage.key} isOpen={showAnnotations} setIsOpen={setShowAnnotations} question={loadedPage} />
      )}

    </>
  )
}

export default Quest
